export default __webpack_public_path__ + "static/media/Ballroll_00276.18bf4b4f.png";